var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-header-6 text-deepsky-900 font-bold mr-2 flex-shrink-0 pl-4 border-l-6 flex-none",class:[_vm.cssClasses]},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }